import { initReactI18next } from "react-i18next";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";

export const SUPPORTED_LANGUAGES = {
  en: "English",
  es: "Español",
} as const;

export type SupportedLanguage = keyof typeof SUPPORTED_LANGUAGES;

void i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: Object.keys(SUPPORTED_LANGUAGES),
    fallbackLng: "es",

    ns: ["translation"],
    defaultNS: "translation",

    keySeparator: false,
    nsSeparator: false,

    interpolation: {
      escapeValue: false,
    },

    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },

    detection: {
      order: ["querystring", "localStorage", "navigator"],
      caches: ["localStorage"],
      lookupQuerystring: "locale",
      lookupLocalStorage: "i18nextLng",
    },

    returnNull: false,
    returnEmptyString: false,
  });

i18n.on("languageChanged", () => {
  if (!window.location.search.includes("locale")) {
    return;
  }

  const url = new URL(window.location.href);

  url.searchParams.delete("locale");
  window.history.replaceState(window.history.state, "", url);
});

export default i18n;
